import React, { useState, useEffect,useCallback } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import Home from './screen/Home';
import MoviePrice from './screen/MoviePrice'; // [영화시세 2026-08-08] 극장별 대행원가 날짜별 입력(공개 메뉴, 입력은 관리자만)
import './App.css';
import { HomeProvider } from './screen/Home/HomeContext';
import Tiketting from './screen/tiketing';
import Navigator from './components/Navigator';
import SubNavigator from './components/SubNavigator';
import CustomerService from './screen/Community';
import Settings from './screen/Settings';
import BuyCoupon from './screen/Settings/BuyCoupon';
import Withdraw from './screen/Settings/Withdraw';
import CouponPurchaseHistory from './screen/Settings/CouponPurchaseHistory';
import CouponUsageHistory from './screen/Settings/CouponUsageHistory';
import PointUsageHistory from './screen/Settings/PointUsageHistory';
import PointDeposit from './screen/Settings/PointDeposit';
import BidsHistory from './screen/tiketing/BidsHistory';

import PostList from './components/Board/PostList';
import PostDetail from './components/Board/PostDetail';
import Editor from './components/Board/Editor';
import { fetchPosts, createPost } from './api';
import PaymentRecords from './screen/Settings/PaymentRecords';
import Footer from './components/Footer';
import AssignOrder from './screen/tiketing/AssignOrder';
import ProcessOrder from './screen/tiketing/ProcessOrder';
import PublicOrderBids from './screen/tiketing/PublicOrderBids';
import PublicOrderList from './screen/tiketing/PublicOrdersList';

import { Login, RegisterForm } from './components/Login';
import MyPage from './components/MyPage';
import { useAuth } from './context/AuthContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedPage from './screen/ProtectedPage';

import styled from 'styled-components';
import BusinessInfo from './components/BusinessInfo';
import UserOptions from './screen/tiketing/UserOptions';
import Header from './components/Header';
import OrderHistory from './screen/Settings/OrderHistory';
import UserCorptax from './screen/Settings/UserCorptax';
import BlockingHistory from './screen/tiketing/BlockingHistory';
import RefundHistory from './screen/tiketing/RefundHistory';
import CancelOrder from './screen/tiketing/CancelOrder';

import PushNotification from './components/PushNotification';

//  추가 영역
import WriteEditorLite from './components/WriteEditorLite';
import UpdateEditorLite from './components/WriteEditorLite/Update';
import PostViewer from './components/PostViewer';
import CSCenter from './screen/CSCenter';
import CSCenterNotice from './screen/CSCenter/CSCenterNotice';
import CSCenterPurchase from './screen/CSCenter/CSCenterPurchase';
import CSCenterInquiries from './screen/CSCenter/CSCenterInquiries';
import LogBox from './LogBox';

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  border-bottom-left-radius:30px;
  border-bottom-right-radius:30px;
`;


const MainWarpper = styled.div`
  flex: 1;
  display: flex;
  
  max-width:1440px;
  flex-direction: column;
  .layout {
    display: flex;
  }

  .navigation {
    width: 250px; /* Adjust width as needed */
  }

  .main-content {
    flex-grow: 1;
    padding: 20px; /* Adjust padding as needed */
  }
`;
const MainContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content:center;
  .layout {
    display: flex;
  }

  .navigation {
    width: 250px; /* Adjust width as needed */
  }

  .main-content {
    flex-grow: 1;
    padding: 20px; /* Adjust padding as needed */
  }
`;

const FloatingButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 50px;
  padding: 10px 20px;
  font-size: 16px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 1000;

  &:hover {
    background-color: #2980b9;
  }
`;
// SlideUpViewer styled component
const SlideUpViewer = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out;
  transform: ${props => (props.isVisible ? 'translateY(0)' : 'translateY(100%)')};
  height: ${props => props.height}px;  /* 높이 상태에 따라 동적 높이 설정 */
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;
// SlideUpHeader styled component
const SlideUpHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
  cursor: ns-resize;  /* 드래그 가능한 영역을 나타내는 커서 */
  padding:0.5rem;
`;

// SlideUpBody styled component (스크롤을 위한 내용 컨테이너)
const SlideUpBody = styled.div`
  flex: 1;
  overflow-y: auto;  /* 내용이 많을 경우 스크롤 가능하도록 */
  padding: 1rem;
`;


function FloatingCustomerServiceButton() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/CSCenter/Inquiries');
  };

  return (
    <FloatingButton onClick={handleClick}>
      1:1 문의하기
    </FloatingButton>
  );
}

function App() {
  const {logout, login, isLoggedIn, user } = useAuth();
  const [posts, setPosts] = useState([]);
  const [notices, setNotices] = useState(['환영합니다.']);
  const [error, setError] = useState(null);
  const [permissionGranted, setPermissionGranted] = useState(false);

  const [isLogViewerVisible, setIsLogViewerVisible] = useState(false);
  const [debugInput, setDebugInput] = useState('');
  const [height, setHeight] = useState(300);  // 기본 높이를 300px로 설정
  const [isDragging, setIsDragging] = useState(false);
  const [startY, setStartY] = useState(0);
  const [startHeight, setStartHeight] = useState(300);  // 기본 높이를 상태로 저장
 // 로그 뷰어 닫기 함수
 const closeLogViewer = () => {
  //console.log('Closing log viewer');  // 상태 변화 디버깅용 로그
  setIsLogViewerVisible(false);
};
const handleKeyPress = useCallback(
  (event) => {
    // 엔터 키를 눌렀을 때만 입력된 값이 "log"인지 확인
    if (event.key === 'Enter') {
      if (debugInput === 'log') {
        setIsLogViewerVisible(true);
      }
      // 입력 초기화
      setDebugInput('');
    } else {
      // 엔터 외의 키는 계속해서 입력값에 추가
      setDebugInput((prevInput) => prevInput + event.key.toLowerCase());
    }
  },
  [debugInput]
);
//알람 권한 요청!
useEffect(() => {
  if ('Notification' in window) {
    // 알림 권한 요청
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        setPermissionGranted(true);
        console.log('알림 권한이 허용되었습니다.');
      } else {
        console.log('알림 권한이 거부되었습니다.');
      }
    });
  }
}, []);

// 서비스 워커 등록!
useEffect(() => {
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    // 서비스 워커를 등록
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered with scope:', registration.scope);
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  }
}, []);  // []는 컴포넌트가 처음 마운트될 때 한 번만 실행

  // 마우스 드래그 시작
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartY(e.clientY);
    setStartHeight(height);
  };

  // 마우스 드래그 중 높이 변경
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const newHeight = startHeight + (startY - e.clientY);
    if (newHeight >= 100 && newHeight <= window.innerHeight * 0.9) {  // 최소 100px, 최대 화면 90% 높이
      setHeight(newHeight);
    }
  };

 // 마우스 드래그 종료
 const handleMouseUp = () => {
  setIsDragging(false);
};

// 키보드 이벤트 리스너 등록 및 해제
useEffect(() => {
  window.addEventListener('keypress', handleKeyPress);
  window.addEventListener('mousemove', handleMouseMove);
  window.addEventListener('mouseup', handleMouseUp);
  return () => {
    window.removeEventListener('keypress', handleKeyPress);
    window.removeEventListener('mousemove', handleMouseMove);
    window.removeEventListener('mouseup', handleMouseUp);
  };
}, [handleKeyPress, handleMouseMove]);

useEffect(() => {
  // 서버에서 데이터를 fetch하는 함수
  const fetchNotices = async () => {
    try {
      const response = await fetch('/request/line-notice');
      const data = await response.json();
      setNotices(data);
    } catch (error) {
      console.error('Error fetching notices:', error);
    }
  };
  fetchNotices();
}, []);



  useEffect(() => {
    const fetchSessionData = async () => {
      try {
        const response = await fetch('/request/session', {
          credentials: 'include',
        });
  
        if (response.ok) {
          const userData = await response.json();
          login(userData); // 로그인 함수로 세션 데이터 반영
        } else if (response.status === 401) {
          console.warn('세션이 만료되었거나 유효하지 않습니다. 다시 로그인하세요.');
          logout(); // 세션 만료 처리
        } else {
          console.error('세션 데이터를 가져오는 중 오류가 발생했습니다:', response.statusText);
        }
      } catch (error) {
        console.error('Error fetching session data:', error);
      }
    };
  
    // 로그인된 상태에서만 세션을 유지하려고 시도
    if (isLoggedIn) {
      fetchSessionData();
    }
  }, [login, logout, isLoggedIn]);
  




  return (
    <AuthProvider>
      <AppContainer>
        <Header notices={notices}/>
        <Navigator />
        {isLoggedIn && permissionGranted && <PushNotification userId={user?.id} />}
        <MainContainer>
          <MainWarpper>
          <Routes>
            <Route path="/" element={<HomeProvider><Home /></HomeProvider>} />
            <Route path="/MoviePrice" element={<MoviePrice />} /> {/* [영화시세 2026-08-08] 공개 라우트(ProtectedRoute 미사용), 입력은 서버가 관리자 재검증 */}
            <Route path="/Login" element={<Login />} />
            <Route path="/Register" element={<RegisterForm />} />
            <Route path="/protected" element={<ProtectedRoute element={<ProtectedPage />} />} />
            <Route path="/Tiketting/*" element={<ProtectedRoute element={<Tiketting />} />}>
              <Route path="AssignOrder" element={<AssignOrder />} />
              <Route path="UserOptions" element={<UserOptions />} />
              <Route path="process-order/:orderId" element={<ProcessOrder />} />
              <Route path="PublicOrderBids" element={<PublicOrderBids />} />
              <Route path="PublicOrderList" element={<PublicOrderList />} />
              <Route path="PublicOrderBids/:menuId" element={<PublicOrderBids />} />
              <Route path="BidsHistory" element={<BidsHistory />} />

              <Route path="OrderHistory" element={<OrderHistory />} />
              <Route path="BlockingHistory" element={<BlockingHistory />} />
              <Route path="RefundHistory" element={<RefundHistory />} />
              <Route path="CancelOrder" element={<CancelOrder />} />
            </Route>
            <Route path="/process-order/:menuId" element={<ProcessOrder />} />
            <Route path="/CSCenter/*" element={<ProtectedRoute element={<CSCenter />} />}>
                <Route path="Notices" element={<CSCenterNotice />} />
                <Route path="Support" element={<CSCenterPurchase />} />
                <Route path="Inquiries" element={<CSCenterInquiries />} />
                <Route path="Notices/:id" element={<PostViewer />} key="PostViewer" />
                <Route path="Support/:id" element={<PostViewer />} key="PostViewer" />
                <Route path="Inquiries/:id" element={<PostViewer />} key="PostViewer" />
                <Route path="Create" element={<WriteEditorLite />} key="WriteEditorLite" />
                <Route path="Update/:id" element={<UpdateEditorLite />} key="UpdateEditorLite" />
              </Route>
            <Route path="/Settings" element={<ProtectedRoute element={<Settings />} />}>
              <Route path="Notice" element={<div>Notice</div>} />
              <Route path="Board" element={<div>Board</div>} />
              <Route path="Orderboard" element={<div>Orderboard</div>} />
              <Route path="BuyCoupon" element={<BuyCoupon/>}/>
              <Route path="CouponPurchaseHistory" element={<CouponPurchaseHistory/>}/>
              <Route path="PointDeposit" element={<PointDeposit/>}/>
              <Route path="CouponUsageHistory" element={<CouponUsageHistory/>}/>
              <Route path="PointUsageHistory" element={<PointUsageHistory/>}/>
              <Route path="Withdraw" element={<Withdraw/>}/>
              <Route path="OrderHistory" element={<OrderHistory />} />
              <Route path="PaymentRecords" element={<PaymentRecords />} />
              <Route path="MyPage" element={<MyPage />} />
              <Route path="Business-info" element={<BusinessInfo />} />
              <Route path="UserOptions" element={<UserOptions />} />
              <Route path="UserCorptax" element={<UserCorptax />} />
            </Route>
          </Routes>
          </MainWarpper>
        </MainContainer>
        <Footer />
        <FloatingCustomerServiceButton />
       {/* Slide-up 로그 뷰어 */}
       <SlideUpViewer isVisible={isLogViewerVisible} height={height}>
        <SlideUpHeader onMouseDown={handleMouseDown}>
          <label>Debug Log Viewer</label>
          <button onClick={closeLogViewer}>Close</button>
        </SlideUpHeader>
        <SlideUpBody>
          <LogBox/>
        </SlideUpBody>
      </SlideUpViewer>
      </AppContainer>
    </AuthProvider>
  );
}

export default App;
